
export const Card1img = require('./section2a-card1img.svg').default;  
export const Card2img = require('./section2a-card2img.svg').default;  
export const Card3img = require('./section2a-card3img.svg').default;  
export const Card4img = require('./section2a-card4img.svg').default;  
export const ClientDecor = require('./section2a-clientsdecor.svg').default;  

export const Grid1img = require('./section2b-grid1img.svg').default;
export const Grid2img = require('./section2b-grid2img.svg').default;
export const Grid3img = require('./section2b-grid3img.svg').default;
export const Grid4img = require('./section2b-grid4img.svg').default;

export const BrandName = require('./ReWORX-BrandName.png').default;

export const Grid5img = require('./section2b-grid5img.svg').default;
export const Grid6img = require('./section2b-grid6img.svg').default;
export const Grid7img = require('./section2b-grid7img.svg').default;
export const Grid8img = require('./section2b-grid8img.svg').default;
export const Grid9img = require('./section2b-grid9img.svg').default;